import { inject, observer } from 'mobx-react';
import { pushToTicketDetailForVG } from '../../liveRouting';
import * as stores from '../../liveStores';
import { TicketListContainerBase } from '../ticketList/ticketListContainerBase';

@inject(stores.ApplicationStoreKey)
@observer
export class LiveTicketListForVGContainer extends TicketListContainerBase {

    canShowPotentialWin = false;

    get store() {
        return this.props.applicationStore.ticketListForVG;
    }

    componentWillMount() {
        (this.props.applicationStore as any).setCanShowLeftColumn(true);
        this.props.applicationStore.ticketListTypeSelector.setVGAsActive();
        super.componentWillMount();
    }

    goToDetail(ticketId: string) {
        pushToTicketDetailForVG(ticketId);
    }
}